import { render } from "./EquipamentoSecretariaSelect.vue?vue&type=template&id=8128982c"
import script from "./EquipamentoSecretariaSelect.vue?vue&type=script&lang=js"
export * from "./EquipamentoSecretariaSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__